<template>
  <div
    v-if="visible"
    ref="breadcrumbCardRef"
    :class="`${bem.b()} ${rootClass}`"
    :style="rootStyle"
  >
    <div :class="bem.e('container')">
      <!-- 头部导航栏 -->
      <div :class="bem.e('header')">
        <!-- 左边返回 -->
        <a-breadcrumb :class="bem.e('back')">
          <a-breadcrumb-item class="icon" @click="handleClose">
            <ll-icon
              icon-name="icon-return-arrow"
              class="back-icon"
              :class="bem.e('back-icon')"
            />
          </a-breadcrumb-item>
          <a-breadcrumb-item :class="bem.e('title')">
            {{ title }}
          </a-breadcrumb-item>
        </a-breadcrumb>
        <!-- 头部右边插槽 -->
        <slot name="extra" />
      </div>
      <!-- 内容区域 -->
      <div :class="`${bem.e('content')}`" v-bind="$attrs">
        <!-- 内容滚动区域 -->
        <div ref="scrollRef" :class="`${bem.e('content-container')}`">
          <slot />
        </div>
      </div>
      <!-- 底部footer -->
      <div
        v-if="$slots.footer"
        :class="`${bem.e('footer')} ${
          isShowContentBottomBox ? bem.e('footer-shadow') : ''
        }`"
      >
        <slot name="footer" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, computed } from 'vue'
import { createNamespace } from '@ll-plus/utils'
import { useScroll } from '@ll-plus/hooks'

import { breadcrumbCardProps, breadcrumbCardEmits } from './breadcrumb-card'

// 1.defineOptions
defineOptions({
  name: 'LlBreadcrumbCard'
})

// 2.props/emits
const props = defineProps(breadcrumbCardProps)
const emits = defineEmits(breadcrumbCardEmits)

// 3.hooks
const { scrollPosition, isHasScrollBar, scrollRef } = useScroll()

// 4.ref/computed/const
const breadcrumbCardRef = ref<HTMLElement>()
// 设置rootStyle获取z-index
const rootStyle = computed(() => {
  return { zIndex: props.zIndex }
})
// 是否显示底部的阴影
const isShowContentBottomBox = computed(() => {
  // 如果顶部的阴影为true则说明是内部的容器在滚动产品的阴影 则由容器的滚动情况来决定阴影
  if (props.footerShadowPlacement === 'inner') {
    return (
      props.isShowFooterShadow &&
      isHasScrollBar.value &&
      scrollPosition.value !== 'bottom'
    )
  } else {
    // 如果顶部的阴影为false，则说明不是内部容器滚动，则底部的阴影由 外部的isShowFooterShadow来决定
    return props.isShowFooterShadow
  }
})
const bem = createNamespace('breadcrumb-card')

// 5.methods
// 点击头部返回图标
const handleClose = async () => {
  emits('update:visible', false)
  emits('close', props.visible)
}
// 6.watchEffect
// 监听添加弹窗的位置
// watchEffect(() => {
//   if (props.visible && breadcrumbCardRef.value) {
//     // 添加到指定的位置下
//     if (isAdd.value) return
//     if (props.getContainer) {
//       const parentNode: any =
//         typeof props.getContainer === 'function'
//           ? props.getContainer()
//           : props.getContainer
//       parentNode.appendChild(breadcrumbCardRef.value!)
//     } else {
//       // 添加到body下
//       document.body.appendChild(breadcrumbCardRef.value!)
//     }
//     isAdd.value = true
//   }
// })

// 滚动条返回顶部
const scrollTop = () => {
  if (scrollRef && scrollRef.value) {
    scrollRef.value.scrollTop = 0
    scrollPosition.value = 'top'
  }
}

// 7.defineExpose
defineExpose({
  scrollTop
})
</script>
